'use strict';

module.exports = linkReference;

var normalize = require('mdurl/encode');
var failsafe = require('../failsafe');
var all = require('../all');

/* Transform a reference to a link. */
function linkReference(h, node) {
  var def = h.definition(node.identifier);
  var props = {href: normalize((def && def.url) || '')};

  if (def && def.title !== null && def.title !== undefined) {
    props.title = def.title;
  }

  return failsafe(h, node, def) || h(node, 'a', props, all(h, node));
}



//////////////////
// WEBPACK FOOTER
// ./~/remark-html/~/mdast-util-to-hast/lib/handlers/link-reference.js
// module id = 227
// module chunks = 96961042003272 139266963665775